import { apiClient } from './client';
import type { Category, Envelope } from './types';

export type CreateCategoryInput = {
  name: string;
  color?: string;
  icon?: string;
};

export async function listCategories(): Promise<Category[]> {
  const res = await apiClient.get<Envelope<Category[]>>('/categories');
  return res.data.data;
}

export async function createCategory(input: CreateCategoryInput): Promise<Category> {
  const res = await apiClient.post<Envelope<Category>>('/categories', input);
  return res.data.data;
}

export async function deleteCategory(id: number): Promise<void> {
  await apiClient.delete(`/categories/${id}`);
}
